import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import { AlertTypes } from '../../components/types';

export interface IAppState {
  loading: boolean;
  locationCode: string;
  alert: {
    isOpen: boolean;
    type: AlertTypes;
    childern: any;
  };
}

const initialState: IAppState = {
  loading: true,
  locationCode: '10100',
  alert: {
    isOpen: false,
    type: 'success',
    childern: null,
  },
};

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    triggerAlert(state, action) {
      state.alert = {
        isOpen: true,
        type: action?.payload?.type,
        childern: action?.payload?.childern,
      };
    },
    closeAlert(state) {
      state.alert = {
        isOpen: false,
        type: 'success',
        childern: null,
      };
    },
    appLoadingStart(state) {
      state.loading = true;
    },
    appLoadingCompleted(state) {
      state.loading = false;
    },
    setLocationCode(state, action) {
      state.locationCode = action?.payload;
    },
  },
});

export const { actions } = appSlice;

export const selectApp = (state: RootState): IAppState => state.app;

export default appSlice.reducer;
